const FILTER_OPTIONS = [
  { label: 'Lançamentos futuros', name: 'future' },
  { label: 'Lançamentos realizados', name: 'realized' },
  { label: 'Lançamentos em atraso', name: 'late' },
];

export default FILTER_OPTIONS;
